module.exports = {
    live4tv: {
        api_url: process.env.REACT_APP_API_BASE_URL || 'https://api.live4.tv',
        studio_url: process.env.REACT_APP_STUDIO_BASE_URL || 'https://studio.live4.tv',
    },
    livekit: {
        // Use environment variables with fallbacks
        // For local development, use ws:// and http://
        // For production, use wss:// and https://
        ws_url: process.env.REACT_APP_LIVEKIT_WS_URL || 'wss://livekit.live4.tv',
        http_url: process.env.REACT_APP_LIVEKIT_HTTP_URL || 'https://livekit.live4.tv',
    },
    languages: ['pt', 'en', 'es'],
    fallbackLng: 'en',
    namespace: 'translation',
    supportedStreamTargets: [
        'instagram',
        'facebook',
        'youtube',
        'rtmp',
        'tiktok',
    ],
    twitch: {
        client_id: 'hnxjzncxd6qpuk2rew5a05g7cly8a3',
    },
    sentryDsn: 'https://ab7adff6de074ead93bbb9d21db672cb@o810798.ingest.sentry.io/5805124',
    plan: {
        code: 'standard',
    },
    webrtc: {
        wssURL: 'wss://5fa0b37d2a2bd.streamlock.net/webrtc-session.json',
        applicationName: 'live'
    },
    restream: {
        host: 'rtmp://go.live4.tv:1936',
    },
    gtm: {
        id: 'GTM-58XMD8NV',
    },
    hotjar: {
        siteId: '2128173',
        version: '6',
    },
    google: {
        client_id: '493192240270-2sf09rmvclbieiuhs00u5ilp5jam2ttd.apps.googleusercontent.com',
    },
    facebook: {
        app_id: '869394440316955',
    },
    stripe: {
        public_key: 'pk_live_51M0Is1J6RgBGfFphfXVkFCSAxAYAk3zceZzCFYxEgA2O8Pqb8rALhtkJVctwroL0w0BQKVphgIWDqukph4tRgw8R00RLfqCVxP',
        plan_table_id: 'prctbl_1NcPDMJ6RgBGfFphUUGmwHMd',
        dashboard_url: 'https://billing.stripe.com/p/login/3cs6pgaQOahwaeQeUU',
    }
}
